import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as lmsAction from "../../../../redux/actions/lmsAction";
import * as lmsUserAction from "../../../../redux/actions/lmsUserAction";
import * as toolboxAction from "../../../../redux/actions/toolBoxAction";
import * as lmsReportAction from "../../../../redux/actions/lmsReportAction";
import { useSelector } from "react-redux";
import Loader from "../../../../library/common/Loader";
import Items from "../component/items";
import { ORG_ID, USER_ID, PAGE_SIZE_500 } from "../../../../constant/constant";
import { toast, ToastContainer } from "react-toastify";
const ItemsContainerLMS = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const page = location?.state?.page;
  const apiData = location?.state?.apiData;
  const [typeselectdata, setTypeselectdata] = useState(
    location?.state?.typeselectdata ?? [],
  );
  const [emailSendStatus, setEmailSendStatus] = useState(null);
  useEffect(() => {
    handleClear();
  }, []);

  const getLmsDashboardReportDetails = useSelector(
    (state) => state.getLmsDashboardReportDetails,
  );
  const getAssignLessonUserListData = useSelector(
    (state) => state?.getAssignLessonUserList,
  );
  const coursesUserAssignListData = useSelector(
    (state) => state?.getAssignCourseUserList,
  );
  const coursesUserListData = useSelector((state) => state.getUserCoursesList);

  const lessionUserListData = useSelector((state) => state.getUserLessonsList);

  const getToolBoxTalkListResult = useSelector(
    (state) => state.mySafetyMeetingList,
  );
  const getScheduleAssignUserStatusData = useSelector(
    (state) => state.getAssignTookBoxUser,
  );
  const getScheduleInstructorDetailsData = useSelector(
    (state) => state.getScheduleInstructorDetails,
  );
  const getScheduleInstructorDetailsIsLoading = useSelector(
    (state) => state.getScheduleInstructorDetails?.isLoading,
  );

  const getLmsCourseLessonSafetyCompeleted_Detail = useSelector(
    (state) => state.getLmsCourseLessonSafetyCompeleted,
  );
  const isLoading_complelted = useSelector(
    (state) => state.getLmsCourseLessonSafetyCompeleted?.isLoading,
  );
  const getLmsCourseLessonSafetyInCompeleted_Detail = useSelector(
    (state) => state.getLmsCourseLessonSafetyInCompeleted,
  );
  const isLoading_Incomplelted = useSelector(
    (state) => state.getLmsCourseLessonSafetyInCompeleted?.isLoading,
  );

  function getMoretDetails(data, tab) {
    if (data?.isSendEmail || data?.isSendMail || data?.IsSendMail) {
      setEmailSendStatus(true);
    } else {
      setEmailSendStatus(false);
    }
    page === "UsersThatHaveCompleteLesson" // Lessons with Highest Completion
      ? dispatch(lmsAction.getAssignedLessonList(data))
      : page === "TrainingWithLowestParticipation" && tab === "lesson"
        ? dispatch(lmsAction.getAssignedLessonList(data)) // for lesson
        : page === "TrainingWithLowestParticipation" && tab === "course"
          ? dispatch(lmsAction.getAssignedList(data)) // for course
          : page === "TrainingWithLowestParticipation" &&
              (tab === "safety" || tab === "safety meeting")
            ? dispatch(toolboxAction.getScheduleInstructorDetails(data))
            : page === "UsersWithHighestCourseCompletion" // // Course with Highest Completion
              ? dispatch(lmsAction.getAssignedList(data)) //usersWithHighestCompletedTraining
              : page === "usersWithHighestCompletedTraining" &&
                  tab === "Complete"
                ? dispatch(
                    lmsReportAction.getCourseLessonSafetyMeetingComplete(data),
                  )
                : page === "usersWithMostIncompletedTraining" &&
                    tab === "InComplete"
                  ? dispatch(
                      lmsReportAction.getCourseLessonSafetyMeetingInComplete(
                        data,
                      ),
                    )
                  : page === "SubcontractorCompletedTraingings" ||
                      page === "UsersWithMostSafetyMeetings"
                    ? dispatch(toolboxAction.getMySafetyMeetingList(data))
                    : console.log("");
  }
  useEffect(() => {
    page === "UsersThatHaveCompleteLesson"
      ? getMoretDetails({
          pageNumber: 1,
          pageSize: 100,
          lessonId: apiData?.lessonId,
          isCompleted: true,
          fromDate: apiData?.startDate,
          toDate: apiData?.endDate,
          divisionId:
            apiData.divisionId === "AllDivision" ? 0 : apiData.divisionId,
          isSendMail: false,
          groupId: apiData?.groupId ?? 0,
        })
      : page === "UsersWithHighestCourseCompletion"
        ? getMoretDetails({
            pageNumber: 1,
            pageSize: 100,
            courseId: apiData?.courseId,
            isCompleted: true,
            fromDate: apiData?.startDate,
            toDate: apiData?.endDate,
            divisionId:
              apiData.divisionId === "AllDivision" ? 0 : apiData.divisionId,
            isSendMail: false,
            groupId: apiData?.groupId ?? 0,
          })
        : page === "usersWithMostIncompletedTraining"
          ? getMoretDetails(
              {
                pageNumber: 1,
                pageSize: PAGE_SIZE_500,
                search: "",
                catIds: "",
                statusId: 2,
                userId: apiData?.userId,
                orgId: ORG_ID(),
                fromDate: apiData?.startDate,
                toDate: apiData?.endDate,
                divisionId: apiData?.divisionId,
                trainingType: typeselectdata ?? [],
                isSendEmail: false,
                groupId: apiData?.groupId ?? 0,
              },
              "InComplete",
            )
          : page === "usersWithHighestCompletedTraining"
            ? getMoretDetails(
                {
                  pageNumber: 1,
                  pageSize: PAGE_SIZE_500,
                  search: "",
                  catIds: "",
                  statusId: 1,
                  userId: apiData?.userId,
                  orgId: ORG_ID(),
                  fromDate: apiData?.startDate,
                  toDate: apiData?.endDate,
                  divisionId: apiData?.divisionId,
                  trainingType: typeselectdata ?? [],
                  IsSendMail: false,
                  groupId: apiData?.groupId ?? 0,
                },
                "Complete",
              )
            : page === "SubcontractorCompletedTraingings"
              ? getMoretDetails({
                  page: 1,
                  pageSize: PAGE_SIZE_500,
                  search: "",
                  userId: apiData?.userId,
                  tabId: 3,
                  divisionId:
                    apiData.divisionId === "AllDivision"
                      ? 0
                      : apiData.divisionId,
                  fromDate: apiData.startDate,
                  toDate: apiData.endDate,
                  IsInstructor: false,
                  isSendMail: false,
                  groupId: apiData?.groupId ?? 0,
                })
              : page === "UsersWithMostSafetyMeetings"
                ? getMoretDetails({
                    page: 1,
                    pageSize: PAGE_SIZE_500,
                    search: "",
                    userId: apiData?.userId,
                    tabId: 3,
                    divisionId:
                      apiData.divisionId === "AllDivision"
                        ? 0
                        : apiData.divisionId,
                    fromDate: apiData.startDate,
                    toDate: apiData.endDate,
                    IsInstructor: true,
                    isSendMail: false,
                    groupId: apiData?.groupId ?? 0,
                  })
                : page === "TrainingWithLowestParticipation" &&
                    location?.state?.type === "Course"
                  ? getMoretDetails(
                      {
                        pageNumber: 1,
                        pageSize: PAGE_SIZE_500,
                        courseId: apiData?.courseId,
                        isCompleted: false,
                        fromDate: apiData.startDate,
                        toDate: apiData.endDate,
                        divisionId:
                          apiData.divisionId === "AllDivision"
                            ? 0
                            : apiData.divisionId,
                        isSendMail: false,
                        groupId: apiData?.groupId ?? 0,
                      },
                      "course",
                    )
                  : page === "TrainingWithLowestParticipation" &&
                      location?.state?.type === "Lesson"
                    ? getMoretDetails(
                        {
                          pageNumber: 1,
                          pageSize: PAGE_SIZE_500,
                          lessonId: apiData?.lessonId,
                          isCompleted: false,
                          fromDate: apiData.startDate,
                          toDate: apiData.endDate,
                          divisionId:
                            apiData.divisionId === "AllDivision"
                              ? 0
                              : apiData.divisionId,
                          isSendMail: false,
                          groupId: apiData?.groupId ?? 0,
                        },
                        "lesson",
                      )
                    : page === "TrainingWithLowestParticipation" &&
                        location?.state?.type === "Safety Meeting"
                      ? getMoretDetails(
                          {
                            userId: apiData?.userId,
                            orgId: ORG_ID(),
                            fromDate: apiData.startDate,
                            toDate: apiData.endDate,
                            divisionId:
                              apiData?.divisionId === "AllDivision"
                                ? 0
                                : apiData?.divisionId,
                            filterBy: 3,
                            toolboxTalkId: apiData?.toolboxTalkId,
                            toolboxTalkVersionId: apiData?.toolboxTalkVersionId,
                            //scheduleId: apiData?.scheduleId,
                            page: 1,
                            pageSize: PAGE_SIZE_500,
                            isSendMail: false,
                            groupId: apiData?.groupId ?? 0,
                          },
                          "safety",
                        )
                      : console.log();
  }, []);
  const userTRainingLoadin =
    coursesUserListData.isLoading ||
    lessionUserListData.isLoading ||
    getToolBoxTalkListResult.isLoading ||
    getScheduleInstructorDetailsData.isLoading ||
    getScheduleInstructorDetailsIsLoading;

  function handleClear() {
    dispatch(lmsUserAction.clearCourseList());
    dispatch(lmsUserAction.clearLesssonList());
    dispatch(lmsAction.getAssignedLessonListClear());
    dispatch(lmsAction.getAssignedListClear());
    dispatch(toolboxAction.scheduleUserCountStatusClear());
    dispatch(lmsReportAction.clearDashboardDetails());
    dispatch(toolboxAction.clearMySafetyMeetingList());
    dispatch(lmsReportAction.clearCourseLessonSafetyMeetingComplete());
    dispatch(lmsReportAction.clearCourseLessonSafetyMeetingInComplete());
  }

  useEffect(() => {
    if (
      getLmsCourseLessonSafetyInCompeleted_Detail.status === "SUCCESS" &&
      emailSendStatus
    ) {
      toast.success("Data has been sent to your email successfully!");
    }
  }, [getLmsCourseLessonSafetyInCompeleted_Detail]);

  useEffect(() => {
    if (coursesUserAssignListData.status === "SUCCESS" && emailSendStatus) {
      toast.success("Data has been sent to your email successfully!");
    }
  }, [coursesUserAssignListData]);

  useEffect(() => {
    if (getAssignLessonUserListData.status === "SUCCESS" && emailSendStatus) {
      toast.success("Data has been sent to your email successfully!");
    }
  }, [getAssignLessonUserListData]);

  useEffect(() => {
    if (getToolBoxTalkListResult.status === "SUCCESS" && emailSendStatus) {
      toast.success("Data has been sent to your email successfully!");
    }
  }, [getToolBoxTalkListResult]);

  useEffect(() => {
    if (
      getLmsCourseLessonSafetyCompeleted_Detail.status === "SUCCESS" &&
      emailSendStatus
    ) {
      toast.success("Data has been sent to your email successfully!");
    }
  }, [getLmsCourseLessonSafetyCompeleted_Detail]);

  useEffect(() => {
    if (
      getScheduleInstructorDetailsData.status === "SUCCESS" &&
      emailSendStatus
    ) {
      toast.success("Data has been sent to your email successfully!");
    }
  }, [getScheduleInstructorDetailsData]);

  useEffect(() => {
    if (Array.isArray(location?.state?.typeselectdata)) {
      setTypeselectdata(location.state.typeselectdata);
    }
  }, [location?.state?.typeselectdata]);

  return (
    <div>
      {(getLmsDashboardReportDetails.isLoading ||
        getAssignLessonUserListData?.isLoading ||
        coursesUserAssignListData?.isLoading ||
        getScheduleAssignUserStatusData.isLoading ||
        isLoading_complelted ||
        isLoading_Incomplelted ||
        getScheduleInstructorDetailsIsLoading) && <Loader />}
      <Items
        page={page}
        getLmsDashboardReportDetails={getLmsDashboardReportDetails}
        getMoretDetails={getMoretDetails}
        apiData={apiData}
        lessonUserAssignListData={getAssignLessonUserListData?.dataresult}
        coursesUserAssignListData={coursesUserAssignListData?.dataresult}
        coursesUserListData={coursesUserListData?.data}
        lessionUserListData={lessionUserListData?.data}
        getToolBoxTalkListResult={getToolBoxTalkListResult?.data}
        getScheduleAssignUserStatusData={
          getScheduleAssignUserStatusData?.data?.users
        }
        location={location}
        userTRainingLoadin={userTRainingLoadin}
        handleClear={handleClear}
        getScheduleInstructorDetailsData={getScheduleInstructorDetailsData}
        getLmsCourseLessonSafetyCompeleted_Detail={
          getLmsCourseLessonSafetyCompeleted_Detail?.data?.result
        }
        getLmsCourseLessonSafetyInCompeleted_Detail={
          getLmsCourseLessonSafetyInCompeleted_Detail?.data?.result
        }
        typeselectdata={typeselectdata}
        setTypeselectdata={setTypeselectdata}
      />
      <ToastContainer />
    </div>
  );
};

export default ItemsContainerLMS;
